/* eslint-disable import/prefer-default-export */
export const idSortablegridNoItems = 'sortablegrid-no-items';
export const idSacHeader = 'sac-header';
export const idSacHeaderIcon = 'sac-header-icon';
